// extracted by mini-css-extract-plugin
module.exports = {"card":"staticChannel_card__7FonT","strip":"staticChannel_strip__R_c8J"};